import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
} from "./type";
import secureLocalStorage from "react-secure-storage";
import AuthService from "../services/auth_service";
import UserService from '../services/user_service';

export const register = (first_name, last_name, email, password, botcode) => (dispatch) => {
  return AuthService.register(first_name, last_name, email, password, botcode).then(
    (response) => {
      dispatch({
        type: REGISTER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.detail) ||
        error.detail ||
        error.toString();

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const login = (email, password) => (dispatch) => {
  return AuthService.login(email, password).then(() => UserService.getUserProfile().then(
    (response) => {
      secureLocalStorage.setItem('user', JSON.stringify(response.data));
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: response.data },
      });
      return Promise.resolve();

    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.detail) ||
        error.detail ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  ))
};

export const googleLogin = (state, code, code_verifier, error) => (dispatch) => {
  return AuthService.getGoogleCallback(state, code, code_verifier, error).then(() => UserService.getUserProfile().then(
    (response) => {
      secureLocalStorage.setItem('user', JSON.stringify(response.data));
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: response.data },
      });
      return Promise.resolve();

    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.detail) ||
        error.detail ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  ))
};

export const logout = () => (dispatch) => {
  return AuthService.logout().then(() => {
    dispatch({
      type: LOGOUT,
      payload: { user: null }
    });
    return Promise.resolve();
  },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.detail) ||
        error.detail ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    });

};

export const request_restore_password = (email, botcode) => (dispatch) => {
  return AuthService.requestNewPassword(email).then(
    (data) => {
      if (data === null) {
        dispatch({
          type: SET_MESSAGE,
          payload: "Message with password restore instructions was sent to your email"
        })
      }
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.detail) ||
        error.detail ||
        error.toString();

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const change_password = (token, password) => (dispatch) => {
  return AuthService.resetPassword(token, password).then(
    (data) => {


      return Promise.resolve();
    },
    (error) => {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.detail) ||
        error.detail ||
        error.toString();

      if (message === 'RESET_PASSWORD_BAD_TOKEN') {
          message = 'Your token is already invalid. Please, request restoring password again';
      }

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};